<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>
<div *ngIf="usuario && usuario.sucesso" class="container-fluid" [ngClass]="usuario.retorno.aparencia">
    <div style="margin-top: 20px;">
        <ul class="breadcrumb">
            <li><strong>Onde estou:</strong></li>
            <li class="active">
                <span id="lblSubMenu">Cadastro de <b>SubFrotas</b></span>
            </li>
        </ul>
        <div class="clearfix">
            <div class="pull-right subfrotas-botoes">
                <button class="btn btn-default btn-primary btn-primary-negativo" (click)="isCollapsed = ! isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseFilter"><i class="fa fa-filter"></i>
                    Filtrar
                    resultados</button>
                <a [ngClass]="!permissaoIncluir ? 'disabled' : ''" routerLink="incluir" class="btn btn-primary"><i class="fa fa-sitemap"></i> Incluir SubFrota</a>
                <a [ngClass]="!permissaoTransferirVeiculos ? 'disabled' : ''" href="{{ urlTransferirVeiculos }}"
                    onclick="return(window.confirm('Você será redirecionado para o Cadastro de Veículos, onde a transferência poderá ser feita. Confirma ?'));"
                    class="btn btn-primary" disabled="true"><i class="fa fa-truck"></i> Transferência Veículos
                </a>
                <button class="btn btn-primary btn-primary-negativo"
                    (click)="exporter.exportTable('xlsx', {fileName:getXLSName(), sheet: 'SubFrotas', Props: {Author: 'CTF'}})"
                    title="Realiza a exportação da consulta no formato Excel."><i
                        class="fa fa-file-excel-o"></i>Excel</button>
            </div>
        </div>
        <aside #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
            <div class="panel panel-default form-filtrar form-default">
                <form (ngSubmit)="onSubmit()" #filtroForm="ngForm" class="panel-body">
                    <h1>Filtrar resultados</h1>
                    <div class="row">
                        <div class="col-md-9 form-group">
                            <app-filtro-frota *ngIf="usuario.retorno.tipo != tipoEntidades.frota"
                                (onFrotaSelected)="selecionaFrota($event)"></app-filtro-frota>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 form-group">
                            <label class="center-block">
                                UF
                            </label>
                            <mat-select name="uf" [(ngModel)]="filtro.uf" class="form-control dropdown-filtro"
                                matTooltip="Pesquise pela UF da SubFrota">
                                <mat-option value="">Todas</mat-option>
                                <mat-option *ngFor="let uf of ufs" [value]="uf.codigo">{{uf.sigla}}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 form-group" style="display: inline-block;">
                            <label class="center-block">
                                Centro de Custo
                            </label>
                            <mat-radio-group value="" name="flagCentroCusto" aria-label="Selectione uma opção"
                                matTooltip="Pesquise se a SubFrota é de Faturamento"
                                [(ngModel)]="filtro.flagCentroCusto">
                                <mat-radio-button value="" class="radio-filtro">TODOS</mat-radio-button>
                                <mat-radio-button value="S" class="radio-filtro">SIM</mat-radio-button>
                                <mat-radio-button value="N" class="radio-filtro">NÃO</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="offset-md-9 col-md-3 text-center">
                            <button type="submit" class="btn btn-primary btn-submit">
                                <i class="fa fa-filter"></i>Filtrar
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </aside>
        <div>
            <mat-form-field class="pesquisa-filtro">
                <input matInput #txtVal (keyup)="applyFilter(txtVal.value)"
                    placeholder="Digite para pesquisar Sub Frota ...">
            </mat-form-field>
        </div>

        <div class="lista-container">

            <mat-table matTableExporter [dataSource]="dataSource" matSort #exporter="matTableExporter"
                [hiddenColumns]="[0]">

                <ng-container matColumnDef="actions" stickyEnd>
                    <mat-header-cell *matHeaderCellDef style="border-bottom-width:0px; height: 30px;"> &nbsp;
                    </mat-header-cell>>
                    <mat-cell *matCellDef="let row">
                        <button class="icon-button" [matMenuTriggerFor]="appMenu" aria-label="">
                            <img class="icon" src="./assets/img/ico-options.png" />
                        </button>
                        <mat-menu #appMenu="matMenu">
                            <button [disabled]="!permissaoAlterar ? true : null" mat-menu-item
                                (click)="rowAction('alterar', row)">Alterar
                            </button>
                            <button [disabled]="!permissaoConsultar ? true : null" mat-menu-item
                                (click)="rowAction('consultar', row)">Consultar
                            </button>
                            <button [disabled]="row.flagPadrao === 'S' || !permissaoExcluir ? true : null" mat-menu-item
                                (click)="rowAction('excluir', row)">Excluir
                            </button>
                        </mat-menu>
                    </mat-cell>
                </ng-container>

                <!-- Código SubFrota Column -->
                <ng-container matColumnDef="codigo">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> CÓDIGO </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.codigo}} </mat-cell>
                </ng-container>

                <!-- Identificador Column -->
                <ng-container matColumnDef="codigoIdentificacao">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>RESUMIDO </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.codigoIdentificacao}} </mat-cell>
                </ng-container>

                <!-- Nome Column -->
                <ng-container matColumnDef="descricao">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>FANTASIA</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.descricao}} </mat-cell>
                </ng-container>

                <!-- Cidade Column -->
                <ng-container matColumnDef="cidade">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>CIDADE</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.cidade}} </mat-cell>
                </ng-container>

                <!-- UF Column -->
                <ng-container matColumnDef="uf">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>UF</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.uf}} </mat-cell>
                </ng-container>

                <!-- UF Column -->
                <ng-container matColumnDef="flagCentroCusto">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>C.&nbsp;CUSTO</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.flagCentroCusto === 'S' ? 'SIM' : 'NÃO'}} </mat-cell>
                </ng-container>

                <!-- UF Column -->
                <ng-container matColumnDef="flagPadrao">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>PADRÃO</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.flagPadrao === 'S' ? 'SIM' : 'NÃO'}} </mat-cell>
                </ng-container>


                <!-- CNPJ Column -->
                <ng-container matColumnDef="cnpj">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>CNPJ</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.cnpj}} </mat-cell>
                </ng-container>

                <!-- Código Frota Column -->
                <ng-container matColumnDef="codigoFrota">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>CÓD.&nbsp;FROTA</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.codigoFrota.toString().padStart(6,'0')}} </mat-cell>
                </ng-container>

                <!-- Frota Column -->
                <ng-container matColumnDef="nomeReduzidoFrota">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>FROTA</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.nomeReduzidoFrota}} </mat-cell>
                </ng-container>

                <!-- Qtde Veículos Column -->
                <ng-container matColumnDef="qtdeVeiculos">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>VEÍCULOS</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.qtdeVeiculos}} </mat-cell>
                </ng-container>

                <!-- Bloqueio Postos Novos Column -->
                <ng-container matColumnDef="flagBloqueioPostoNovo">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>C.&nbsp;BLOQUEIOPOSTONOVO</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.flagBloqueioPostoNovo === '1' ? 'SIM' : 'NÃO'}} </mat-cell>
                </ng-container>

                <!-- Flag Bloqueio Postos Novos Column -->
                <ng-container matColumnDef="flagMostrarBloqueioPostoNovo">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>C.&nbsp;FLAGBLOQUEIOPOSTONOVO</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.flagMostrarBloqueioPostoNovo === '1' ? 'SIM' : 'NÃO'}} </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;">
                </mat-row>
            </mat-table>


            <mat-paginator #paginator class="filter-paginator" [pageSizeOptions]="[10, 20, 50, 100, 500, 1000, 9999]"
                [pageSize]="10" aria-label="Seleciona a página">
            </mat-paginator>


        </div>
    </div>
</div>
